module.exports = __webpack_public_path__ + "static/media/banner.87e60eda.png";